module.exports = __webpack_public_path__ + "static/media/acne.9dac9c0a.svg";